import React, { useState } from 'react'
import styled from '@emotion/styled'
import { L1ReasonableButton } from '../l1/L1Button'
import { useTheme } from '@emotion/react'
import { FusionColor } from '../../../theme/FusionStyle'
import L1TextArea from '../l1/L1TextArea'
import { L2Dialog, L2DialogProps } from '../l2/L2Dialog'
import L1CommentCard from '../l1/L1CommentCard'
import { Comment, commentIsEditable } from '@fusion-advantage/formlib'

const AddCommentDialogContent = styled.div(({theme}) => ({
	padding: theme.spacing(2),
	backgroundColor: theme.colors[FusionColor.Second],
	gap: 10,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-start',
	flexDirection: 'column',
	color: theme.colors[FusionColor.InputLabel],
}))

const CommentsDialogFooter = styled.div(({theme}) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	padding: theme.spacing(2, 5)
}))

const CommentsDialogContent = styled.div(({theme}) => ({
	padding: theme.spacing(2),
	backgroundColor: theme.colors[FusionColor.Second],
	gap: 8,
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	flexDirection: 'column',
	overflow: 'scroll',
	minHeight: theme.spacing(45),
	maxHeight: theme.spacing(45),
	color: theme.colors[FusionColor.InputLabel],
}))

interface L3ReadCommentDialogProps extends L2DialogProps {
	comments: Comment[]
	encounterAppLastStatusDT?: string
	onEditClick?: (idx: number) => void,
	onAddClick?: React.MouseEventHandler,
	onClose: () => void,
}

export const L3ReadCommentDialog = ({ comments, encounterAppLastStatusDT, onEditClick, onAddClick, show, onClose, title, size }: L3ReadCommentDialogProps) => {
	const theme = useTheme()

	return (
		<L2Dialog
			show={show}
			onClose={onClose}
			title={title}
			size={size || 'min'}
		>
			<CommentsDialogContent>
				{
					comments?.map((comment, idx) => (
						<L1CommentCard
							key={idx}
							comment={comments[idx]}
							editable={(encounterAppLastStatusDT && onEditClick) ? commentIsEditable(comments[idx], encounterAppLastStatusDT) : false}
							onEdit={() => {
								if(onEditClick) {
									onEditClick(idx)
								}
							}}
						/>
					))
				}
			</CommentsDialogContent>
			<CommentsDialogFooter>
				<L1ReasonableButton 
					label='Add Comment'
					disabled={!onAddClick}
					onClick={onAddClick}
					wide={true}
				/>
			</CommentsDialogFooter>
		</L2Dialog>
	)
}

interface L3EditCommentDialogProps extends L2DialogProps {
	existingMessage?: string,
	onSave: (message: string) => void,
	onClose: () => void,
}

export const L3EditCommentDialog = ({existingMessage, onSave, onClose, show, size, title}: L3EditCommentDialogProps) => {
	const [message, setMessage] = useState(existingMessage ?? "")
	const theme = useTheme()

	const handleSaveComment = () => {
		onSave(message)
	}

	return (
		<L2Dialog
			title={title}
			show={show}
			onClose={onClose}
			size={size || 'min'}
		>
			<AddCommentDialogContent>
				<label>Comment</label>
				<L1TextArea
					autoFocus
					value={message}
					onChange={(e) => setMessage(e.target.value)}
				/>
			</AddCommentDialogContent>
			<CommentsDialogFooter>
				<L1ReasonableButton 
					label='Confirm Comment'
					onClick={handleSaveComment}
					wide={true}
				/>
			</CommentsDialogFooter>
		</L2Dialog>
	)
}
